<template>
  <div>
    <b-field
      :label="$t('fields.labels.name')"
      :type="{ 'is-danger': errors.name }"
      :message="errors.name ? errors.name[0] : ''"
      :custom-class="errors.name ? 'has-text-danger' : ''">
      <b-input type="text" :placeholder="$t('fields.placeholders.name')"
        v-model="formData.name" :value="formData.name" required />
    </b-field>

    <b-field
      :label="$t('fields.labels.email')"
      :type="{ 'is-danger': errors.email }"
      :message="errors.email ? errors.email[0] : ''"
      :custom-class="errors.email ? 'has-text-danger' : ''">
      <b-input type="email" :placeholder="$t('fields.placeholders.email')"
        v-model="formData.email" :value="formData.email" required
        :disabled="this.formData.id === 1" />
    </b-field>

    <b-field
      :label="$t('fields.labels.enterprise')"
      :type="{ 'is-danger': errors.enterprise }"
      :message="errors.enterprise ? errors.enterprise[0] : ''"
      :custom-class="errors.enterprise ? 'has-text-danger' : ''">
      <b-input type="text" :placeholder="$t('fields.placeholders.enterprise')"
        v-model="formData.enterprise" :value="formData.enterprise" required />
    </b-field>

    <b-field
      v-if="$auth.check(['admin', 'support']) && currentPage !== 'my-account'"
      :label="$t('fields.labels.group')"
      :type="{ 'is-danger': errors.group }"
      :message="errors.group ? errors.group[0] : $t('fields.placeholders.group')"
      :custom-class="errors.group ? 'has-text-danger' : ''">
      <users-form-group
        :value.sync="formData.group"
        :default="$t('fields.select')"
        :disabled="this.formData.id === 1" />
    </b-field>

    <b-field
      :label="$t('fields.labels.password')"
      :type="{ 'is-danger': errors.password }"
      :message="errors.password ? errors.password[0] : ''"
      :custom-class="errors.password ? 'has-text-danger' : ''">
      <b-input type="password" :placeholder="$t('fields.placeholders.password')"
        v-model="formData.password" :value="formData.password" password-reveal required />
    </b-field>

    <b-field :label="$t('fields.labels.password_confirmation')">
      <b-input
        type="password"
        :value="formData.password_confirmation"
        v-model="formData.password_confirmation"
        :placeholder="$t('fields.placeholders.password_confirmation')"
        password-reveal required />
    </b-field>
  </div>
</template>

<script>
import UsersFormGroup from './UsersFormGroup'

export default {
  name: 'UsersForm',
  props: {
    user: { type: Object, required: true },
    errors: Object
  },
  components: { UsersFormGroup },
  data () {
    return {
      formData: {
        name: '',
        email: '',
        enterprise: '',
        group: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  mounted () {
    this.formData = this.user
  },
  watch: {
    user () {
      this.formData = this.user
    },
    formData () {
      this.$emit('update:user', this.formData)
    }
  },
  computed: {
    currentPage () {
      return this.$route.name
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "fields": {
      "select": "Select...",
      "labels": {
        "name": "Name",
        "email": "Email",
        "enterprise": "Enterprise",
        "group": "Group",
        "password": "Password",
        "password_confirmation": "Password Confirmation"
      },
      "placeholders": {
        "name": "User name",
        "email": "Email address",
        "enterprise": "User enterprise name",
        "group": "User permissions group",
        "password": "Password",
        "password_confirmation": "Password confirmation"
      }
    }
  },
  "pt-BR": {
    "fields": {
      "select": "Selecione...",
      "labels": {
        "name": "Nome",
        "email": "E-mail",
        "enterprise": "Empresa",
        "group": "Grupo",
        "password": "Senha",
        "password_confirmation": "Confirmação da senha"
      },
      "placeholders": {
        "name": "Nome do usuário",
        "email": "Endereço de e-mail",
        "enterprise": "Nome da empresa do usuário",
        "group": "Grupo de permissões do usuário",
        "password": "Senha de acesso",
        "password_confirmation": "Confirmação da senha"
      }
    }
  }
}
</i18n>
